<template>
  <div>
    <Card>
      <template #content>
        <div class="d-flex flex-column align-items-center w-100">
          <div v-if="!bcps">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
          <FormatTable
            v-else-if="bcps.length"
            :formats="bcps"
            :is-rule-manager="false"
            class="w-100"
            @select-format="gotoShow"
          />
          <div v-else class="d-flex align-items-center">
            <span>データが存在しません</span>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useFormats, useRouterUtil } from "/@/vue/composables";
import { List as FormatsList } from "/@/vue/components/Molecules/Format";
import { Table as FormatTable } from "/@/vue/components/Organisms/Users/Formats";
import Card from "primevue/card";

const { goto } = useRouterUtil();

const { getFormats } = useFormats();
const { data: formats } = getFormats({
  types: ["bcp"],
});

const bcps = computed(() => {
  if (!formats.value) return [];

  return formats.value;
});

function gotoShow(id: number) {
  const target = bcps.value.find((format) => format.id === id);
  const pdfUrl = target?.attachedPdfs[0].url;
  window.open(pdfUrl, "_blank");
}
</script>

<style scoped></style>
